<template>
  <div :id="uniqueId"></div>
</template>

<script setup lang="ts">
import qrcode from 'qrcode-generator';
import { onMounted, useId, watch } from 'vue';

export type ScannerQrCodeProps = {
  data: string;
  type?: TypeNumber;
  errorCorrectionLevel?: ErrorCorrectionLevel;
  cellSize?: number;
  margin?: number;
  scalable?: boolean;
};

const props = withDefaults(defineProps<ScannerQrCodeProps>(), {
  data: '',
  type: 0,
  errorCorrectionLevel: 'L',
});
const uniqueId = useId();

onMounted(() => {
  watch(
    props,
    ({ data, errorCorrectionLevel, type, cellSize, margin, scalable }) => {
      const qr = qrcode(type, errorCorrectionLevel);
      qr.addData(data);
      qr.make();
      document.getElementById(uniqueId)!.innerHTML = qr.createSvgTag({
        cellSize,
        margin,
        scalable,
      });
    },
    { immediate: true },
  );
});
</script>
